"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionEvaluator = void 0;
const ScriptEvaluator_1 = require("./ScriptEvaluator");
const ConditionEvaluationError_1 = require("../utils/ConditionEvaluationError");
class ConditionEvaluator {
    /**
     * Evaluate a condition script
     * @param conditionScript The condition script to evaluate
     * @param player The player context
     * @param gameSession The game session
     * @param adventureManager The adventure manager
     * @param variableStore Optional variable store
     * @param optionId The ID of the option being evaluated (for error reporting)
     * @param friendsService Optional friends service
     * @throws {ConditionEvaluationError} If condition evaluation fails
     */
    static evaluate(conditionScript, player, gameSession, adventureManager, variableStore, optionId, friendsService, adventureInviteService, asyncOperationService, inviteLinkService, emailService, emailActionTokenService, verificationCodeService, analyticsService, entitiesService, foreignEntityLookup) {
        // No condition = always true
        if (!conditionScript)
            return true;
        // Execute script
        try {
            return ScriptEvaluator_1.ScriptEvaluator.executeCondition(conditionScript, player, gameSession, variableStore, adventureManager, friendsService, adventureInviteService, asyncOperationService, inviteLinkService, emailService, emailActionTokenService, verificationCodeService, analyticsService, entitiesService, foreignEntityLookup);
        }
        catch (error) {
            // Create a descriptive error message
            const errorMessage = error instanceof Error
                ? error.message
                : String(error);
            throw new ConditionEvaluationError_1.ConditionEvaluationError(`Failed to evaluate condition for option '${optionId || 'unknown'}': ${errorMessage}`, conditionScript, optionId || 'unknown', player.id, error instanceof Error ? error : undefined);
        }
    }
}
exports.ConditionEvaluator = ConditionEvaluator;
//# sourceMappingURL=ConditionEvaluator.js.map